<template>
    <div class="page">
        <div class="page-header">
        </div>
        <div class="page-main">
            <ul class="module-list" :style="{height: `${containerHeight}px`}">
                <template v-for="(moduleItem, index) in moduleList">
                    <li v-if="isMyModule(moduleItem) && moduleItem.state === 1" class="module-item"  @click="jumpToPage('moduleDetail', {id: moduleItem.id})">
                        <div class="module-item__pic" :style="{backgroundImage: `url(${moduleItem.logoUrl})`}"></div>
                        <div class="module-item__info">
                            <el-tooltip class="item" effect="dark" :content="moduleItem.name" placement="top">
                                <div class="module-item__name">{{moduleItem.name}}</div>
                            </el-tooltip>

                            <div class="module-item__count">{{moduleItem.notBatchCount}}</div>
                        </div>
                    </li>
                    <li v-else class="module-item module-item--grey">
                        <div class="module-item__pic" :style="{backgroundImage: `url(${moduleItem.logoUrl})`}"></div>
                        <div class="module-item__info">
                            <el-tooltip class="item" effect="dark" :content="moduleItem.name" placement="top">
                                <div class="module-item__name">{{moduleItem.name}}</div>
                            </el-tooltip>
                            <div class="module-item__count">&nbsp;</div>
                        </div>
                    </li>
                </template>

            </ul>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin.js';

    import { getTrainTypeListByMangerUser } from '@/api/affairs/affairs';

    import {mapGetters} from 'vuex';

    export default {
        name: "moduleSetting",
        data() {
            return {
                moduleList: [],
                containerHeight: 0
            }
        },
        created() {
            getTrainTypeListByMangerUser()
                .then(res => res.data)
                .then(data => {
                    if(data.result) {
                        this.moduleList = data.data;
                    }
                })
        },
        mounted() {
            this.containerHeight = window.innerHeight - 300;
        },
        mixins: [baseMixin],
        computed: {
            ...mapGetters(['userInfo'])
        },
        methods: {
            // 判断是否是用户的板块
            isMyModule(item) {
                return JSON.parse(item.manUserJson).some(userItem => userItem.id === this.userInfo.id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../commonsPC/styles/mixins";

    @include reset-global;

    .page {
        padding: 20px;
        box-sizing: border-box;
    }
    .page-main {
    }
    .module-list {
        overflow: auto;
        padding: 0 30px;
        box-sizing: border-box;
    }
    .module-item {
        float: left;
        width: 24%;
        height: 120px;
        padding: 5px;
        margin: 30px 0;
        cursor: pointer;
        position: relative;
        &.module-item--grey {
            filter: grayscale(1);
            cursor: default;
        }
        &:hover {
            .module-item__name, .module-item__count {
                color: #409eff !important;
            }
        }
        & > * {
            @include middleIB;
        }
        .module-item__pic {
            @include wh(100px, 100px);
            @include cover-bg;
            margin-bottom: 5px;
            margin-right: 22px;
        }
        .module-item__info {
            width: 140px;
        }
        .module-item__name {
            text-align: left;
            @include nowrap;
            color: #878686;
            font-size: 22px;
        }
        .module-item__count {
            margin-top: 16px;
            font-size: 34px;
            color: #2ca8cb;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/affairs/moduleList.vue